import { LockAlertIcon } from './LockAlertIcon';

/**
 * author: Simran
 * id 6AFF2FDC-D4F8-41F6-8B80-908D1AB87424
 * name lock-alert
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-alert.svg
 * tags
 * - Lock 
 * - Alert / Error 
 * - Home Automation 
 */
export const PasswordAlertIcon = LockAlertIcon;
export default PasswordAlertIcon